export const priceFormat = (number = '') => {
  const [f, s] = String(number).replace(',', '.').split('.');
  return `${f.replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')}${s ? `,${s}` : ''}`;
};
